import React from 'react';
import { BlockTypeProps } from '../../../../typings/interfaces/block-type-props';

const EmptySpace: React.FC<BlockTypeProps> = ({blockNode}) => {
    return (
       <span></span>
    )
}
export default EmptySpace;